import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const FormInputError = ({ errorText, className }) => {
  return <div className={classNames('invalid-feedback d-block', className)}>{errorText}</div>;
};

FormInputError.propTypes = {
  errorText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FormInputError;
